import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  avatarWrapper: {
    width: 'auto',
    '& .MuiAvatar-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiAvatar-root:has(img)': {
      backgroundColor: '#fff',
      backgroundImage: 'none',
    },
  },

  pendingAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '1px dashed #898793',
  },

  roundIcon: {
    borderRadius: '50%',
  },
  squareIcon: {
    borderRadius: '10px',
  },
  color_primary: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  color_secondary: {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
  color_white: {
    border: `1px solid ${theme.palette.custom.white}`,
  },
  color_none: {
    border: 'none',
  },
}));
